import React from 'react';
import Typography from '@material-ui/core/Typography';
import displayText from '../PpsiForm/displayText.json';

function PpiIfoodDiscontinueText() {
  return (
    <div>
      <Typography style={{ color: '#FF0000', marginRight: '20px' }}>
        {displayText.ingredientiFoodDiscontinueText}
      </Typography>
    </div>
  );
}

export default PpiIfoodDiscontinueText;
